import { render } from "./ExpertiseBoxesAlt.vue?vue&type=template&id=b259c6a0"
import script from "./ExpertiseBoxesAlt.vue?vue&type=script&lang=js"
export * from "./ExpertiseBoxesAlt.vue?vue&type=script&lang=js"

import "./ExpertiseBoxesAlt.vue?vue&type=style&index=0&id=b259c6a0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__